export default "__VITE_ASSET__f2e43860__"